<template>
  <div class="content">
    <div class="content-entries" v-show="!show">
      <div
        class="content-entries-item"
        v-for="item in list"
        :key="item.index"
        @click="handleContent(item)"
      >
        <span class="title">
          <img :src="serverURL + 'images/矢量智能对象3.png'" alt="" />
          {{ item.title }}
        </span>
        <span>{{ item.time }}</span>
      </div>
    </div>
    <div class="content-text" v-show="show">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'intro-content',
  components: {},
  props: ['show', 'list', 'content'],
  data() {
    return {
      text: '',
    }
  },
  watch: {
    content() {
      this.text = this.content
    },
  },
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleContent(v) {
      this.text = v.body
      this.$emit('change', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 45vh;
  padding: 3.703vh 3.125vw;
  p {
    color: #777777;
    font-size: 0.8333vw;
    line-height: 1.75;
    text-indent: 2rem;
  }
  &-entries {
    &-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2.77vh;
      img {
        width: 0.9375vw;
        height: 1rem;
        margin-right: 10px;
        cursor: pointer;
      }
      .title {
        display: flex;
        align-items: center;
      }
    }
  }
  &-text {
    div {
      overflow: hidden;
    }
  }
}
</style>